import React, { FC, useEffect, useState } from 'react';
import { Pie } from 'react-chartjs-2';
import { useTranslation } from 'react-i18next';
import { HostProvider } from '../../../utils/HostProvider';

type Props = {
  data: number[];
  conceptoSocio: number;
  conceptoOfertas: number;
  conceptoPuntosTravel: number;
};
const PieCharts: FC<Props> = ({
  data,
  conceptoSocio,
  conceptoOfertas,
  conceptoPuntosTravel,
}) => {
  const { t } = useTranslation();
  const [data1, setData1] = useState<any>(null);
  const [options, setOptions] = useState<any>(null);
  const isEroski = HostProvider.isEroski();

  // Colores
  const color1 = isEroski ? '#cd0810' : '#36b4e3';
  const color2 = '#e6bd02';
  const color3 = '#0f69b2';
  const ArrayColors: any[] = [];

  // Labels
  const label1 = t('ahorros.por-socio');
  const label2 = t('ahorros.por-ofertas');
  const label3 = t('ahorroscanjeo-puntos');
  const ArrayLabels: any[] = [];

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (conceptoSocio <= 0) data.splice(0, 1);

    if (data.length === 2 && conceptoOfertas <= 0) data.splice(0, 1);
    else if (data.length === 3 && conceptoOfertas <= 0) data.splice(1, 1);

    if (data.length === 1 && conceptoPuntosTravel <= 0) data.splice(0, 1);
    else if (data.length === 2 && conceptoPuntosTravel <= 0) data.splice(1, 1);
    else if (data.length === 3 && conceptoPuntosTravel <= 0) data.splice(2, 1);

    if (conceptoSocio > 0) {
      ArrayColors.push(color1);
      ArrayLabels.push(label1);
    }
    if (conceptoOfertas > 0) {
      ArrayColors.push(color2);
      ArrayLabels.push(label2);
    }
    if (conceptoPuntosTravel > 0) {
      ArrayColors.push(color3);
      ArrayLabels.push(label3);
    }

    setData1({
      labels: ArrayLabels,
      datasets: [
        {
          data,
          backgroundColor: ArrayColors,
          borderWidth: 0,
        },
      ],
    });
    setOptions({
      responsive: true,
      maintainAspectRatio: true,
      rotation: 0.6,
      legend: {
        display: false,
      },
      tooltips: {
        enabled: false,
      },
      events: ['false'],
      animation: {
        duration: 500,
        onComplete: (e: any) => {
          const { ctx } = e.chart;
          ctx.font = 'bold 16px Arial';
          ctx.textAlign = 'center';
          ctx.textBaseline = 'bottom';
          ctx.display = 'block';
          // eslint-disable-next-line @typescript-eslint/no-unused-vars
          let sum = 0;
          e.chart.config.data.datasets.forEach((dataset: any) => {
            // eslint-disable-next-line no-plusplus
            for (let i = 0; i < dataset.data.length; i++) {
              sum += dataset.data[i];
            }
            sum = dataset.data.reduce((a: number, b: number) => a + b, 0);

            // eslint-disable-next-line no-plusplus
            for (let i = 0; i < dataset.data.length; i++) {
              const model =
                // eslint-disable-next-line no-underscore-dangle
                dataset._meta[Object.keys(dataset._meta)[0]].data[i]._model;
              // eslint-disable-next-line no-underscore-dangle
              const { total } = dataset._meta[Object.keys(dataset._meta)[0]];
              const mid_radius =
                model.innerRadius + (model.outerRadius - model.innerRadius) / 2;
              const start_angle = model.startAngle;
              const end_angle = model.endAngle;
              const mid_angle = start_angle + (end_angle - start_angle) / 2;

              const x = mid_radius * Math.cos(mid_angle);
              const y = mid_radius * Math.sin(mid_angle);

              ctx.fillStyle = '#fff';
              if (i === 3) {
                // Darker text color for lighter background
                ctx.fillStyle = '#444';
              }
              const NumRound = parseFloat(
                ((dataset.data[i] / total) * 100).toFixed(1),
              );
              const percent = NumRound > 0 ? `${NumRound}%` : '';
              // Display percent in another line, line break doesn't work for fillText
              ctx.fillText(percent, model.x + x, model.y + y + 15);
            }
          });
        },
      },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  return (
    <>
      <Pie data={data1} options={options} redraw />
    </>
  );
};

export default PieCharts;
